import { DateStr, toDateRange } from '@mi-front/core';
import pick from 'lodash/pick';
import moment from 'moment';
import { OptionTypeBase } from 'react-select/src/types';
import { apiClient } from '../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { useStationsQueryParamParser } from '../../../../../core/hooks/useStationsQueryParamParser';
import { ReportView } from '../../../../../core/reports/components/ReportView';
import { useStations } from '../../../../../core/stations/hooks/useStations';
import { GlobalMissingAudiosReportForm } from './form/form';
import { groupByOptions } from './form/group-by-options';
import { GlobalMissingAudiosReportResult } from './result/result';
import { GlobalMissingAudiosReport } from './types';

type Props = Record<string, never>;

export function GlobalMissingAudiosReportView(p: Props) {
  const stations = useStations();
  const contextTz = useTimezone();

  const defaultValues = {
    ...toDateRange(moment().format('YYYY-MM-DD') as DateStr),
    stations: [],
    groupBy: groupByOptions[0],
    timezone: contextTz,
  };

  return (
    <ReportView<GlobalMissingAudiosReport>
      download={{
        filename: 'missing-audios',
      }}
      defaultValues={defaultValues}
      queryParamsTransform={{
        stations: useStationsQueryParamParser(),
        groupBy: {
          parse: (input) => groupByOptions.find((opt) => opt.id === input)!,
          serialize: (value: OptionTypeBase) => value.id,
        },
      }}
      reportFn={(values, format) => {
        return apiClient.audit.reportMissingAudios({
          ...pick(values, 'from', 'to'),
          stationsIds: (!values.stations.length ? stations : values.stations).map((s) => s.id),
          groupBy: values.groupBy.id,
          options: {
            format,
            timezone: values.timezone || undefined,
          },
        });
      }}
      Form={GlobalMissingAudiosReportForm}
      Result={GlobalMissingAudiosReportResult}
    />
  );
}
